import { render } from "./table-size-changer.vue?vue&type=template&id=9cd9312e&scoped=true"
import script from "./table-size-changer.vue?vue&type=script&lang=js"
export * from "./table-size-changer.vue?vue&type=script&lang=js"

import "./table-size-changer.vue?vue&type=style&index=0&id=9cd9312e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd9312e"]])

export default __exports__